export default __webpack_public_path__ + "static/media/rAmazon.936a0da8.jpg";